import { render, staticRenderFns } from "./CustomFieldItemForm.vue?vue&type=template&id=cc8b2398&scoped=true&"
import script from "./CustomFieldItemForm.vue?vue&type=script&lang=js&"
export * from "./CustomFieldItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8b2398",
  null
  
)

export default component.exports